/**
 * The API surface, in one import.
 *
 *   import { api } from "../api";
 *   const { projects } = await api.projects.list();
 *
 * Namespaced rather than flat because `list` and `get` mean different things
 * per resource, and `api.account.list()` reads better than `listSessions()`
 * imported from somewhere the reader has to go and find.
 */
export * as account from "./account";
export * as billing from "./billing";
export { ApiError, rawRequest, request } from "./client";
export * as projects from "./projects";

import * as accountApi from "./account";
import * as billingApi from "./billing";
import * as projectsApi from "./projects";

export const api = {
  account: accountApi,
  billing: billingApi,
  projects: projectsApi,
} as const;
